export const WEB_STORAGE_KEYS = {
  DO_PAYPAL_PURCHASE_VALUE: "doPaypalPurchaseValue",
  PENDING_PAYPAL_PURCHASE_VALUE: "pendingPaypalPurchaseValue",
  SELECTED_PAYMENT_ITEM: "selectedPaymentItem",
};
